import React from 'react';
import { Switch, Route } from 'react-router-dom';
import AddOrEdit from './AddOrEdit';
import List from './List';
import CafeUsers from './users/users';

const Cafes = props => {
  return (
    <Switch>
      <Route path="/cafes/edit" exact render={routeProps => <AddOrEdit {...routeProps} editMode={true} />} />
      <Route path="/cafes/add" exact render={routeProps => <AddOrEdit {...routeProps} editMode={false} />} />
      <Route path="/cafes/users" exact render={routeProps => <CafeUsers {...routeProps} />} />
      <Route path="/" component={List} />
    </Switch>
  );
};

export default Cafes;
